export default __webpack_public_path__ + "static/media/Sass.b8be02c5.png";